// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--syQl6","title":"_1410bfd27b--title--ekCes","location":"_1410bfd27b--location--u8jZB","search-suggest":"_1410bfd27b--search-suggest--MpuLE"};